import { ReactElement, useEffect, useState } from 'react';
import ShadeLoading from './shade-loading/ShadeLoading';
import SandboxPoster from '@/framework/events/SandboxPoster';
import { notification } from 'antd';
import { useTranslation } from '@/services';
import _ from 'lodash';

const SignModel = (): ReactElement => {
    const [props, setProps] = useState({ visible: false } as ShadeLoadingProps);
    const { t } = useTranslation('common', 'wallet');
    // 每个事件来一个
    // 监听 sign wrap
    useEffect(() => {
        const removes = [] as (() => void)[];
        let counter = 0;
        removes[counter++] = SandboxPoster.On('Wallet.Signing', (str: string) => setProps({ visible: true, showLoading: true, swapLoadData: str, type: 'loading' }));
        removes[counter++] = SandboxPoster.On('Wallet.Mint', (str: SwapLoadData) => setProps({ visible: true, showLoading: true, swapLoadData: str, type: 'mint' }));
        removes[counter++] = SandboxPoster.On('Wallet.Burn', (str: SwapLoadData) => setProps({ visible: true, showLoading: true, swapLoadData: str, type: 'burn' }));
        removes[counter++] = SandboxPoster.On('Token.Mint', (str: SwapLoadData) => setProps({ visible: true, showLoading: true, swapLoadData: str, type: 'token.mint' }));
        removes[counter++] = SandboxPoster.On('Token.Create', (str: SwapLoadData) => setProps({ visible: true, showLoading: true, swapLoadData: str, type: 'token.create' }));
        removes[counter++] = SandboxPoster.On('AddLiquidity', (str: SwapLoadData) => setProps({ visible: true, showLoading: true, swapLoadData: str, type: 'liquidity' }));
        removes[counter++] = SandboxPoster.On('RemoveLiquidity', (str: SwapLoadData) => setProps({ visible: true, showLoading: true, swapLoadData: str, type: 'liquidity.remove' }));
        removes[counter++] = SandboxPoster.On('Msg', (str: SwapLoadData) => setProps({ visible: true, showLoading: true, swapLoadData: str, type: 'msg' }));
        removes[counter++] = SandboxPoster.On('Wallet.Ticket', (str: SwapLoadData) => setProps({ visible: true, showLoading: true, swapLoadData: str, type: 'Ticket' }));
        removes[counter++] = SandboxPoster.On('Wallet.Swapping', (str: SwapLoadData) => setProps({ visible: true, showLoading: true, swapLoadData: str, type: 'swap' }));
        removes[counter++] = SandboxPoster.On('Wallet.SignFail', (msg: string) => {
            notification.error({ message: msg });
            setProps({ visible: false, type: 'loading' } as ShadeLoadingProps);
        });
        removes[counter++] = SandboxPoster.On('Wallet.SignSuccess', () => {
            notification.success({ message: t('transaction-submited') });
            setProps({ visible: false, type: 'loading' } as ShadeLoadingProps);
        });
        removes[counter++] = SandboxPoster.On('X402.local', (str: SwapLoadData) => setProps({ visible: true, swapLoadData: str, showLoading: false, type: 'x402.local' }));
        removes[counter++] = SandboxPoster.On('ModelClose', (str: SwapLoadData) => setProps({ visible: false, swapLoadData: str, showLoading: false, type: 'x402.local' }));
        return () => void _.forEach(removes, (o) => o());
    }, [t]);
    return <ShadeLoading {...props} />;
};
export default SignModel;
